import { URL_PARAMS } from '../hooks/DataFetch/constants';

export const getCurrentTabParam = (): string | null =>
  new URLSearchParams(window.location.search).get(URL_PARAMS.TAB);
